














import { Component, Vue } from "vue-property-decorator";
@Component
export default class Exception500 extends Vue {
    toHome(): void {
        this.$router.push({ path: "/" });
    }
}
